import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    padding: '16px 16px 16px 0',
    display: 'flex',
    flexDirection: 'row'
  },

  dashboardContainerContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    overflow: 'hidden',

    '& .swiper': {
      width: '100%',
      maxWidth: 1000,
      paddingBottom: 50
    },

    '& .swiper-pagination': {
      bottom: '0px !important'
    }
  },

  dashboardCardsContainer: {
    width: '100%',
    maxWidth: 1000
  },

  dashboardStatus: {
    padding: 10,
    backgroundColor: '#5778EC',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  dashboardStatusText: {
    width: 110,
    color: '#fff'
  },

  dashboardMoreContentContainer: {
    paddingTop: 16,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  dashboardMoreContentText: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: 600,
    borderBottom: 'solid',
    borderBottomWidth: '2px',
    cursor: 'pointer'
  },

  propertiesContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: 16
  },

  propertiesDivider: {
    width: '100%'
  },

  propertiesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  propertiesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:356px)': {
      paddingRight: 0,
      display: 'inline-flex'
    }
  },

  propertiesTitle: {
    width: 100,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  dashboardSubTitle: {
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 500
  },
  propertiesDividerSubTitle: {
    height: 1,
    width: '100%',
    backgroundColor: '#E5E5E5'
  },

  propertiesButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  propertiesPopup: {
    '& .popup__box': {
      height: 'auto'
    }
  }
}))
